import { useEffect, useRef } from "react";
import { useSettings } from "../context/SettingsContext";

/**
 * Włącza nowy modal tasków w zależności od settinga
 */
export const useTaskModal = () => {
  const isEnabled = useRef(false);
  const { settings } = useSettings();

  const newTaskLookSettingValue = settings?.newLookTask ?? false;

  useEffect(
    function enableTaskDialog() {
      if (newTaskLookSettingValue && isEnabled.current === false) {
        isEnabled.current = true;

        const importTaskAuraCompat = async () => {
          await import("../pages/task/auraCompat");
        };

        importTaskAuraCompat();
      }
    },
    [newTaskLookSettingValue]
  );
};
